import { httpsCallable } from 'firebase/functions'

import { CloudFunction } from '../../../pure-js/enums/CloudFunction'
import { createClientErrorReporter } from '../../../pure-js/libs/ClientErrorReporting'
import { ClientErrorApp, ReportClientErrorRequest, ReportClientErrorResponse } from '../../../pure-js/types/ClientError'
import { functions } from './Firebase'
import config from '../Config'

// Raw httpsCallable, not the shared callFunction wrapper — that wrapper reports its own
// failures through here, so going via it would loop.
const reporter = createClientErrorReporter({
  app: ClientErrorApp.WEB_EVOLVE,
  // On in local, dev and prod alike — dev traffic lands in the -dev channels. Off in unit tests.
  isEnabled: () => config.enableSlackErrorReporting,
  send: (payload) =>
    httpsCallable<ReportClientErrorRequest, ReportClientErrorResponse>(
      functions,
      CloudFunction.reportClientError
    )(payload).then(({ data }) => data)
})

/**
 * Send error notification to Slack via the reportClientError callable.
 * @param error - Error object
 * @param user - Optional user information; only a hint, the backend trusts the auth token
 * @param context - Optional additional context (component name, action, etc.)
 */
export const sendErrorToSlack = reporter.reportError

/**
 * Send critical error notification to Slack (for system-level failures).
 * @param error - Error object
 * @param user - Optional user information; only a hint, the backend trusts the auth token
 * @param context - Additional context
 */
export const sendCriticalErrorToSlack = reporter.reportCriticalError
